<p-sidebar [visible]="true"
           [position]="'right'"
           [baseZIndex]="10000"
           [modal]="true"
           (onHide)="handleSideBarHide()"
           [style]="{width:'700px'}">

    <ng-template pTemplate="header">{{modifierId ? 'Edit Modifier' : 'Add Modifier'}}</ng-template>

    <p-scrollPanel [style]="{width:'100%', height: 'calc(100vh - 220px)'}"
                   [styleClass]="'app-scrollpanel'">
        <div style="padding: 10px">
            <div class="field">
                <div>Image</div>

                <div style="margin-right: 10px">
                    <a href="{{modifier.ImageUrl}}" target="_blank">
                        <img style="max-width: 260px" src="{{modifier.ImageUrl}}" />
                    </a>
                </div>
                <div>
                    <input id="idImgInput"
                           type="file"
                           accept="image/*"
                           style="display: none"
                           (change)="handleImageChange($event)" />

                    <button pButton
                            type="button"
                            label="Upload"
                            class="edit-mod-btn"
                            icon="pi pi-upload"
                            (click)="handleUploadClick()"></button>
                </div>
            </div>

            <div class="field">
                <div>Restaurant</div>
                <p-dropdown [options]="restaurants"
                            [(ngModel)]="modifier.RestaurantId"
                            [optionLabel]="'Name'"
                            [optionValue]="'Id'"
                            [filter]="true"
                            [filterBy]="'Name'"
                            [style]="{width:'100%'}"
                            placeholder="Select Restaurant"
                            [disabled]="modifierId !== 0"
                            [showClear]="false">
                </p-dropdown>
            </div>
            <div class="field">
                <div>Name</div>
                <input pInputText class="edit-mod-field" [(ngModel)]="modifier.Name" />
            </div>
            <div class="field">
                <div>Description</div>
                <input pInputText class="edit-mod-field" [(ngModel)]="modifier.Description" />
            </div>
            <div class="field">
                <div>Plu</div>
                <input pInputText class="edit-mod-field" [(ngModel)]="modifier.Plu" />
            </div>
            <div class="field">
                <p-checkbox [(ngModel)]="isEnabled"
                            [binary]="true"
                            [label]="'Enabled'"></p-checkbox>
            </div>
            <div class="field">
                <p-checkbox [(ngModel)]="modifier.IsMultiSelect"
                            [binary]="true"
                            [label]="'MultiSelect'"></p-checkbox>
            </div>
            <div class="field">
                <div>BasePrice</div>
                <p-inputNumber [(ngModel)]="modifier.BasePrice"
                               [minFractionDigits]="2"></p-inputNumber>
            </div>
            <div class="field">
                <div>DeliveryTax</div>
                <p-inputNumber [(ngModel)]="modifier.DeliveryTax"
                               [minFractionDigits]="2"></p-inputNumber>
            </div>
            <div class="field">
                <div>TakeawayTax</div>
                <p-inputNumber [(ngModel)]="modifier.TakeawayTax"
                               [minFractionDigits]="2"></p-inputNumber>
            </div>
            <div class="field">
                <div>DineInTax</div>
                <p-inputNumber [(ngModel)]="modifier.DineInTax"
                               [minFractionDigits]="2"></p-inputNumber>
            </div>
        </div>
    </p-scrollPanel>

    <hr style="margin-left: -1rem; margin-right: -1rem;" />

    <div class="flex-row" style="padding-left: 10px; padding-right: 10px">
        <div>
            <button pButton
                    type="button"
                    label="Cancel"
                    class="p-button-danger"
                    (click)="handleSideBarHide()"></button>
        </div>

        <div class="filler"></div>

        <div>
            <button pButton
                    type="button"
                    label="{{modifierId ? 'Save' : 'Create'}}"
                    class="edit-mod-btn"
                    (click)="handleSaveClick()"></button>
        </div>
    </div>
</p-sidebar>

<p-toast position="top-right"></p-toast>
